import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { PartCostDisplay } from "#modules/quoteRequestLines/PartCostDisplay";

type Props = {
  quoteRequestLine: QuoteRequestLineDto;
  openDetailsPanel: () => void;
  onRetryPrediction: () => void;
  hasChildren: boolean;
};

export const PredictedState = ({
  quoteRequestLine,
  openDetailsPanel,
  onRetryPrediction,
  hasChildren,
}: Props) => {
  return (
    <PartCostDisplay
      quoteRequestLine={quoteRequestLine}
      openDetailsPanel={openDetailsPanel}
      retryPrediction={onRetryPrediction}
      hasChildren={hasChildren}
    />
  );
};
